import { getKeyMapIdPointMap, getKeyPointMap } from '../utils';
import { TFilterKeyType } from '@opm/components/FilterCommon/types';

type WithKeyPointType = 'FilterSubmit' | 'HistoryFilter';

export type AllFilterPointType = TFilterKeyType | WithKeyPointType;

type ButtonPointType = {
  [key in AllFilterPointType]: { buttonId: string };
};

// 过滤器埋点 buttonId 映射
// 后续的过滤器只能在后面添加，buttonId 保持唯一
export const commonFilter: ButtonPointType = {
  // 特殊操作
  FilterSubmit: { buttonId: '20000000' },
  HistoryFilter: { buttonId: '20000001' },

  // 通用过滤器
  SingleDateRange: { buttonId: '20000002' },
  MultiDateRange: { buttonId: '20000003' },
  TimeRange: { buttonId: '20000004' },
  CountryRegion: { buttonId: '20000005' },
  Channel: { buttonId: '20000006' },
  Language: { buttonId: '20000007' },
  VideoCategory: { buttonId: '20000008' },
  HashtagCategory: { buttonId: '20000009' },

  // Meme 相关
  MemeType: { buttonId: '20000010' },
  MemeElement: { buttonId: '20000011' },
  MemeChannel: { buttonId: '20000012' },
  MemeRegion: { buttonId: '20000013' },

  // Topic New Video 相关
  TopNewVideoViews: { buttonId: '20000014' },
  TopNewVideoLikes: { buttonId: '20000015' },

  // Competitors Ad Creatives 相关
  ADGame: { buttonId: '20000016' },
  ADType: { buttonId: '20000017' },
  ADPlatform: { buttonId: '20000018' },
  ADImpressions: { buttonId: '20000019' },
  ADActiveDays: { buttonId: '20000020' },
  ADChannel: { buttonId: '20000021' },
  ADFirstSeenDateSelect: { buttonId: '20000022' },
  ADLastSeenDateSelect: { buttonId: '20000023' },
  ADCountryRegion: { buttonId: '20000024' },
};

export const FilterButtonPoint: {
  [key in AllFilterPointType]: AllFilterPointType;
} = getKeyPointMap(commonFilter) as {
  [key in AllFilterPointType]: AllFilterPointType;
};

export const FilterNameMapButtonId: {
  [key in AllFilterPointType]: string;
} = getKeyMapIdPointMap(commonFilter) as {
  [key in AllFilterPointType]: string;
};
